import { Component, ViewChild } from '@angular/core';
import { ModalComponent } from '../modal.component/modal.component';

@Component({
  selector: 'app-info-personal-details-modal',
  templateUrl: './info-personal-details.component.html',
  styleUrls: ['./info-personal-details.component.scss']
})
export class InfoPersonalDetailsModalComponent {
  @ViewChild(ModalComponent) public modal: ModalComponent;

  public onCloseClick(): void {
    this.modal.close('closed by click');
  }

  public open(): void {
    this.modal.open();
  }
}


